import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FontAwesome__downgrade",
  "use": "FontAwesome__downgrade-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 18\" id=\"FontAwesome__downgrade\"><path fill=\"#fff\" d=\"m8 17.333 7.143-7.142V9H10.38V.667H5.619V9H.857v1.19L8 17.334Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol